import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import styled from 'styled-components'
// import NavigationRail from './components/NavigationRail'
import { useTagsHandlers } from '../../services/actions/tags/useTagsHandlers'
import { useTagsStore } from '../../stores/tags/useTagsStore'
import { styles } from '../../styles/themes/style'
import { AppRoutes } from '../../interfaces/store/appStore'
import { useCampaignSimulation, DEFAULT_SIM_CONFIG } from './hooks/useCampaignSimulation'
import { useAuthStore } from '../../stores/auth/useAuthStore'
import { hasCampaignsAccess } from '../../services/campaigns/campaignsNavAccess'

interface ICanvasPageProps { }



const CanvasPage: FunctionComponent<ICanvasPageProps> = () => {
    const { loadAllTagsHandler } = useTagsHandlers()
    const { store: { allTags } } = useTagsStore()
    const { store: { workspace, trial } } = useAuthStore()
    const location = useLocation()
    const tagsLoadedRef = useRef(false)
    const campaignsAllowed = hasCampaignsAccess(workspace, trial)

    // Campaign simulation — runs globally, survives all route changes within canvas
    const [simConfig, setSimConfig] = useState(DEFAULT_SIM_CONFIG)
    useCampaignSimulation({ ...simConfig, enabled: campaignsAllowed && simConfig.enabled })
    useEffect(() => {
        const handler = (e: Event) => setSimConfig((e as CustomEvent).detail)
        window.addEventListener('campaignSimConfigChange', handler)
        return () => window.removeEventListener('campaignSimConfigChange', handler)
    }, [])

    // Load full tag list for modals/dropdowns (separate from paginated Tags page list).
    useEffect(()=>{
        if ((location.pathname === AppRoutes.CONNECTIONS || location.pathname === AppRoutes.HOME) && (!allTags || allTags.length === 0) && !tagsLoadedRef.current) {
            loadAllTagsHandler();
            tagsLoadedRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, allTags])

    return <Container>
        {/* <NavigationRail /> */}
        <Outlet />
    </Container>
}

const Container = styled.div`
    width: 100%;
    /* Rail was reserving left space for the canvas content */
    /* padding: 0px 0px 0px ${styles.lengths.railWidth}; */
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    height: 100%;
    position: relative;

    @media (max-width: 575px) {
        padding: 0px 0px 0px 0px;
        gap: 0px;
    }
`
export default CanvasPage
